<div class="row text-left">

    @if (concepts && concepts.length > 0) {

    <div class="col-12">
        <div class="row g-0">
            <!-- <div class="col-12">
                <h6>Henkilöt</h6>
            </div> -->
            <div class="col">
                @if (HasConceptsOfType(conceptType.Person, true)) {
                <h6>Mainitut henkilöt</h6>
                <span class="pill-container" @fadeScattered>
                
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Person && concept.mentioned) {
                    <span class="pill success" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
            <div class="col">
                @if (HasConceptsOfType(conceptType.Person, false)) {
                <h6>Ehdotuksia henkilöihin</h6>
                <span class="pill-container" @fadeScattered>
                
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Person && !concept.mentioned) {
                    <span class="pill fail" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
        </div>
        
        
        
        
        
    </div>

    <div class="col-12">
        <div class="row g-0">
            <!-- <div class="col-12">
                <h6>Ilmiöt</h6>
            </div> -->
            <div class="col">
                @if (HasConceptsOfType(conceptType.Phenomenon, true)) {
                <h6>Mainitut ilmiöt</h6>
                <span class="pill-container" @fadeScattered>
                
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Phenomenon && concept.mentioned) {
                    <span class="pill success" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
            <div class="col">
                @if (HasConceptsOfType(conceptType.Phenomenon, false)) {
                <h6>Ehdotuksia ilmiöihin</h6>
                <span class="pill-container" @fadeScattered>
                
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Phenomenon && !concept.mentioned) {
                    <span class="pill fail" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
        </div>
        
        
        
        
        

        

    </div>

    <div class="col-12">
        <div class="row g-0">
            <!-- <div class="col-12">
                <h6>Ongelmat</h6>
            </div> -->
            <div class="col">
                @if (HasConceptsOfType(conceptType.Problem, true)) {
                <h6>Mainitut ongelmat</h6>
                <span class="pill-container" @fadeScattered>
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Problem && concept.mentioned) {
                    <span class="pill success" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
            <div class="col">
                @if (HasConceptsOfType(conceptType.Problem, false)) {
                <h6>Ehdotuksia ongelmiin</h6>
                <span class="pill-container" @fadeScattered>
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Problem && !concept.mentioned) {
                    <span class="pill fail" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
        </div>
        
        
        
        
        

        
    </div>

    <div class="col-12">
        <div class="row g-0">
            <!-- <div class="col-12">
                <h6>Ratkaisut</h6>
            </div> -->
            <div class="col">
                @if (HasConceptsOfType(conceptType.Solution, true)) {
                <h6>Mainitut ratkaisut</h6>
                <span class="pill-container" @fadeScattered>
                
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Solution && concept.mentioned) {
                    <span class="pill success" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
            <div class="col">
                @if (HasConceptsOfType(conceptType.Solution, false)) {
                <h6>Ehdotuksia ratkaisuihin</h6>
                <span class="pill-container" @fadeScattered>
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Solution && !concept.mentioned) {
                    <span class="pill fail" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
        </div>
        
        
        
        
        
        
        

        

    </div>


    <div class="col-12">
        <div class="row g-0">
            <!-- <div class="col-12">
                <h6>Käsitteet</h6>
            </div> -->
            <div class="col">
                @if (HasConceptsOfType(conceptType.Matter, true)) {
                <h6>Mainitut käsitteet</h6>
                <span class="pill-container" @fadeScattered>
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType === conceptType.Matter && concept.mentioned) {
                    <span class="pill success" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                
                </span>
                }
            </div>
            <div class="col">
                @if (HasConceptsOfType(conceptType.Matter, false)) {
                <h6>Ehdotuksia käsitteisiin</h6>
                <span class="pill-container" @fadeScattered>
                    @for (concept of concepts; track concept) {
                    @if (concept.conceptType == conceptType.Matter && !concept.mentioned) {
                    <span class="pill fail" [ngbTooltip]="concept.conceptReasoning" tooltipClass="pill-tooltip"
                        [ngClass]="{ 'selected': IsConceptSelected(concept) }" (click)="ToggleConceptSelect(concept)">{{
                        concept.concept }}
                        <!--span (click)="OpenModal(concept, content); $event.stopPropagation()" class="info">?</span-->
                    </span>
                    }
                    }
                </span>
                }
            </div>
        </div>
        
    </div>
    } @else {
    <div class="col-12">
        Analyysia ei vielä suoritettu.
    </div>
    }
</div>